/* pdp-shared.js — Shared IntersectionObserver for all PDP sections
   Single instance, no jQuery, no setInterval long-running.
   Loaded once via pdp-hero.liquid (Section A) with `defer`.
*/
(function () {
  'use strict';
  if (window.__ivPdpInit) return;
  window.__ivPdpInit = true;

  var io = null;

  function getObserver() {
    if (io) return io;
    io = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        var e = entries[i];
        if (e.isIntersecting) {
          e.target.dataset.visible = 'true';
          io.unobserve(e.target);
        }
      }
    }, { threshold: 0, rootMargin: '0px 0px -8% 0px' });
    return io;
  }

  function observeSections(root) {
    var scope = root || document;
    var nodes = scope.querySelectorAll('[data-pdp-section]');
    var obs = getObserver();
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      if (el.dataset.observed === 'true') continue;
      el.dataset.observed = 'true';
      if (!el.dataset.visible) el.dataset.visible = 'false';
      // Skip animation if already in viewport (above-the-fold hero)
      var rect = el.getBoundingClientRect();
      if (rect.top < window.innerHeight * 0.92 && rect.bottom > 0) {
        el.dataset.visible = 'true';
      } else {
        obs.observe(el);
      }
    }
  }

  // Sticky-bar mobile trigger (Section M depends on Section A panel achat)
  function initStickyBarTrigger() {
    var bar = document.querySelector('[data-pdp-sticky-bar]');
    var anchor = document.querySelector('[data-pdp-sticky-anchor]');
    if (!bar || !anchor) return;
    var triggerObs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        // Show sticky bar when anchor (panel achat) leaves viewport
        bar.dataset.visible = e.isIntersecting ? 'false' : 'true';
      });
    }, { threshold: 0, rootMargin: '0px 0px -120px 0px' });
    triggerObs.observe(anchor);
  }

  function init() {
    observeSections();
    initStickyBarTrigger();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-observe on Shopify theme editor section reload
  document.addEventListener('shopify:section:load', function (e) {
    observeSections(e.target);
    initStickyBarTrigger();
  });

  // Expose for ad-hoc late-loaded sections
  window.ivPdpObserve = observeSections;
})();
